var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({attrs:{"label":_vm.label,"type":_setup.type,"append-icon":_setup.appendIcon},on:{"click:append":function($event){_setup.isPassword = !_setup.isPassword}},model:{value:(_setup.modelValue),callback:function ($$v) {_setup.modelValue=$$v},expression:"modelValue"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }